export class MicroappQuitFeedbackFilter{
    general: string;
    date: string;
    time: string;
    type: number;
    state: number;
}